// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Preloader = ((($) => {
  const $HeroImg = $('.Hero img');
  const $HeroTitle = $('.Hero h1');
  function init() {
    if($HeroImg.length) {
      $(document).ready(function() {
        $(this);
        setTimeout(function() {
          $(this);
          addClassBlock($HeroImg, 'zoomOutAnimation');
        }, 200);
        setTimeout(function() {
          $(this);
          addClassBlock($HeroTitle, 'textWidth');
        }, 200);

      });
    }

  }

  function addClassBlock(currentBlock, clas) {
    currentBlock.addClass(clas);
  }

  return {
    init,
  };
}))(jQuery);

export default Preloader;



// WEBPACK FOOTER //
// ./src/static/js/modules/preloader.js